import Navigation from "./Navigation";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import CustomCursor from "./CustomCursor";
import GrainOverlay from "./GrainOverlay";
import EyesMascot from "./EyesMascot";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { useEffect, useState, createContext, useContext, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { ThemeProvider, useTheme } from "@/hooks/useTheme";

const ChromeCtx = createContext({ bare: false, setBare: () => {} });
export const useChrome = () => useContext(ChromeCtx);

function LayoutInner({ children }) {
  useLenis();
  const { pathname } = useLocation();
  const { theme } = useTheme();
  const [bare, setBareState] = useState(false);
  const setBare = useCallback((v) => setBareState(v), []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-ink-950 text-ivory">
      <CustomCursor />
      <GrainOverlay />
      {!bare && <Navigation />}
      <main className="relative"><ChromeCtx.Provider value={{ bare, setBare }}>{children}</ChromeCtx.Provider></main>
      {!bare && <FloatingActions />}
      {!bare && <EyesMascot />}
      {!bare && <Footer />}
      <Toaster
        theme={theme === "light" ? "light" : "dark"}
        position="top-center"
        toastOptions={{
          style: {
            background: theme === "light" ? "#FDFBF7" : "#0a0a0a",
            border: "1px solid var(--gold)",
            color: theme === "light" ? "#0A0908" : "#FDFBF7",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default function Layout({ children }) {
  return (
    <ThemeProvider>
      <LayoutInner>{children}</LayoutInner>
    </ThemeProvider>
  );
}
